import React from 'react';

import { Button, Chip } from '@mui/material';
import FileCopyIcon from '@mui/icons-material/FileCopy';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import { UseFormRegister } from 'react-hook-form';

import classes from './UploadFiles.module.scss';
import { LbModal } from '../../modals/LbModal/LbModal';
import { useUploadFiles } from '../../../hooks/useUploadFiles';

type UploadFilesProps = {
  register: UseFormRegister<any>;
  files: File[];
  setFiles: (files: File[]) => void;
};

const UploadFiles = ({ register, files, setFiles }: UploadFilesProps) => {
  const { error, setFilesHandler, deleteFileHandler, errorModalBtnHandler } =
    useUploadFiles(files, setFiles);

  return (
    <>
      <div className={classes.filesContainer}>
        {files?.length > 0 &&
          files.map((item, index) => (
            <div key={item.lastModified}>
              <Chip
                className={classes.chip}
                icon={<FileCopyIcon />}
                label={item.name}
                onDelete={() => deleteFileHandler(index)}
              />
            </div>
          ))}
      </div>
      <label htmlFor="files">
        <Button
          startIcon={<AttachFileIcon />}
          variant="outlined"
          className={classes.uploadBtn}
          component="span"
        >
          <input
            {...register('files')}
            onChange={setFilesHandler}
            id="files"
            type="file"
            multiple
          />
          Attach Files
        </Button>
      </label>
      <LbModal
        open={!!error}
        title="Warning"
        text={`${error} This files was automatically unselected.`}
        primaryBtnConfig={{ text: 'Ok', onClick: errorModalBtnHandler }}
      />
    </>
  );
};

export { UploadFiles };
